/* IDH cart drawer – "Concierge": reserved timer and "Pair it with" suggestions.
   Works alongside the theme's cart.js and cart-drawer.js; the drawer markup is re-rendered by
   Shopify after every change, so each element rebuilds itself from session storage / cache. */
(function () {
  if (window.__idhCartConcierge) return;
  window.__idhCartConcierge = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TIMER_KEY = 'idhCartReserveUntil';
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 }); }
  catch (e) { fmt = { format: function (n) { return '₹' + Math.round(n); } }; }

  /* ---------- reserved timer: counts down, then starts again at the full time ---------- */
  if (!customElements.get('idh-cart-timer')) {
    customElements.define('idh-cart-timer', class extends HTMLElement {
      connectedCallback() {
        this.out = this.querySelector('[data-time]');
        this.ms = Math.max(0.5, parseFloat(this.dataset.minutes) || 2) * 60000;
        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      deadline() {
        var now = Date.now(), d = parseInt(store.get(TIMER_KEY), 10) || 0;
        if (!d || d <= now || d - now > this.ms) {
          d = now + this.ms;
          store.set(TIMER_KEY, String(d));
        }
        return d;
      }
      tick() {
        var s = Math.ceil(Math.max(0, this.deadline() - Date.now()) / 1000);
        var m = Math.floor(s / 60), r = s % 60;
        if (this.out) this.out.textContent = (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
      }
    });
  }

  /* ---------- "Pair it with": Shopify recommendations for the first piece in the bag ---------- */
  var recCache = {};
  function recommendations(productId) {
    if (!recCache[productId]) {
      recCache[productId] = fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    }
    return recCache[productId];
  }
  function imageUrl(src, width) {
    if (!src) return '';
    var url = typeof src === 'string' ? src : (src.src || src.url || '');
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function needsChoice(p) {
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    return names.some(function (n) { return /size/i.test(n); });
  }

  if (!customElements.get('idh-cart-upsell')) {
    customElements.define('idh-cart-upsell', class extends HTMLElement {
      connectedCallback() {
        var self = this, pid = this.dataset.productId;
        this.rail = this.querySelector('[data-rail]');
        this.err = this.querySelector('[data-error]');
        if (!pid || !this.rail) return;
        var exclude = (this.dataset.exclude || '').split(',').filter(Boolean);
        this.addEventListener('click', this.onClick.bind(this));
        recommendations(pid).then(function (data) {
          if (!self.isConnected) return;
          var list = (data.products || []).filter(function (p) {
            return p.available && exclude.indexOf(String(p.id)) === -1;
          }).slice(0, 6);
          if (!list.length) return;
          self.rail.innerHTML = list.map(self.card).join('');
          self.hidden = false;
        });
      }
      card(p) {
        var variant = (p.variants || []).filter(function (v) { return v.available; })[0];
        var choose = needsChoice(p) || !variant;
        var img = imageUrl(p.featured_image, 160);
        var action = choose
          ? '<a class="idh-cc__card-btn" href="' + esc(p.url) + '">Choose size</a>'
          : '<button class="idh-cc__card-btn" type="button" data-add="' + variant.id + '">Add to bag</button>';
        return '<div class="idh-cc__card">' +
          '<a class="idh-cc__card-img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</a>' +
          '<div><a class="idh-cc__card-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="idh-cc__card-price">' + fmt.format((p.price || 0) / 100) + '</span></div>' +
          action + '</div>';
      }
      onClick(e) {
        var btn = e.target.closest('[data-add]');
        if (!btn) return;
        e.preventDefault();
        var self = this;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        if (this.err) this.err.textContent = '';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.add), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            if (json.status) throw new Error(json.description || json.message || 'Could not add');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && json.sections && typeof drawer.renderContents === 'function') drawer.renderContents(json);
            else window.location.href = root + 'cart';
          })
          .catch(function (err) {
            btn.disabled = false;
            btn.textContent = 'Add to bag';
            if (self.err) self.err.textContent = (err && err.message) || 'Could not add this piece. Please try again.';
          });
      }
    });
  }

})();
